import React, { useEffect, useState } from 'react';

import { InputGroup, TextArea } from '../../../../../../Styles';

const Description = ({ label = 'Description', value = '', error = '', disabled = false, onChange = null, onError = null }) => {
	const [inputValue, setInputValue] = useState(value);

	const validate = () => {
		let error = null;

		if (!inputValue) {
			error = `${label} cannot be empty.`;
		} else if (inputValue?.length > 500) {
			error = `${label} is too long.`;
		}

		onError(error);
		return !error;
	};

	useEffect(() => {
		validate();
		onChange(inputValue);
	}, [inputValue]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<InputGroup
			label={label}
			markRequired={true}
			inputLength={(inputValue || '').length}
			maxLength={500}
			error={error}
		>
			<TextArea
				name={'reason_description'}
				placeholder='Enter value'
				value={inputValue}
				disabled={disabled}
				onChange={(e) => {
					setInputValue(e.target.value);
				}}
				error={error}
			/>
		</InputGroup>
	);
};

export default Description;
